import { hotTrends } from "@/mocks/melonData";

export default function HotTrend() {
  return (
    <section id="hot" className="mx-auto max-w-6xl px-4 md:px-6 py-16 md:py-20">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-fire-fill" /> 实时热度榜
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">正在上头的瓜</h2>
          <p className="mt-3 max-w-lg text-sm text-foreground-600 md:text-base">
            综合浏览量、互动与更新新鲜度排序。热度会随后续、反转与最新进展实时变化。
          </p>
        </div>
        <span className="inline-flex items-center gap-2 self-start rounded-full bg-accent-100/80 px-4 py-2 text-xs text-accent-800">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
          </span>
          每 10 分钟自动更新
        </span>
      </div>

      <ol className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
        {hotTrends.map((item, i) => (
          <li key={item.title}>
            <a
              href="#feed"
              className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-100/60 p-4 hover:border-primary-300 hover:bg-background-50 transition-colors"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-heading text-xl ${
                  i < 3
                    ? "bg-primary-500 text-background-50"
                    : i < 5
                      ? "bg-secondary-100 text-secondary-700"
                      : "bg-background-200 text-foreground-600"
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
                <p className="mt-1 flex items-center gap-2 text-xs text-foreground-600">
                  <span className="truncate">{item.target}</span>
                  <span
                    className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${item.tone}`}
                  >
                    {item.tag}
                  </span>
                </p>
              </div>
              <span
                className={`flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-semibold ${
                  item.up ? "text-secondary-600" : "text-foreground-600"
                }`}
              >
                <i className={`${item.up ? "ri-arrow-up-line" : "ri-arrow-down-line"}`} />
                {item.delta}
              </span>
            </a>
          </li>
        ))}
      </ol>
    </section>
  );
}